import * as DLRubaQuiz from '../DL/RubaQuiz';

const GetQuestions = async () => {
    try {
        const response = await DLRubaQuiz.GetQuestions();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al intentar cargar las preguntas.' };
    }
};

const SubmitQuiz = async (name, email, phone, selectedOptionIds, acceptedTerms) => {
    try {
        const payload = {
            name,
            email,
            phone,
            selectedOptionIds,
            acceptedTerms
        };
        const response = await DLRubaQuiz.SubmitQuiz(payload);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al enviar tus respuestas.' };
    }
};

const GetSettings = async () => {
    try {
        const response = await DLRubaQuiz.GetSettings();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar la configuración del overlay.' };
    }
};

const GetAdminParticipants = async () => {
    try {
        const response = await DLRubaQuiz.GetAdminParticipants();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar el ranking.' };
    }
};

const ToggleVisibility = async (id) => {
    try {
        const response = await DLRubaQuiz.ToggleVisibility(id);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al actualizar el estado del registro.' };
    }
};

const SelectWinner = async (id) => {
    try {
        const response = await DLRubaQuiz.SelectWinner(id);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al establecer el ganador.' };
    }
};

const UpdatePosition = async (offset) => {
    try {
        const response = await DLRubaQuiz.UpdatePosition(offset);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar desplazar la pantalla.' };
    }
};

const UpdateBannerMode = async (mode) => {
    try {
        const response = await DLRubaQuiz.UpdateBannerMode(mode);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la configuración del banner.' };
    }
};

const UpdateOverlayVisibility = async (visible) => {
    try {
        const response = await DLRubaQuiz.UpdateOverlayVisibility(visible);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la visibilidad del overlay.' };
    }
};

const ToggleActiveTrivia = async (active) => {
    try {
        const response = await DLRubaQuiz.ToggleActiveTrivia(active);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar cambiar el estado de la trivia.' };
    }
};

const TrackMetric = async (eventName, sessionId, source) => {
    try {
        const response = await DLRubaQuiz.TrackMetric(eventName, sessionId, source);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar guardar la métrica.' };
    }
};

const GetAdminStats = async () => {
    try {
        const response = await DLRubaQuiz.GetAdminStats();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar obtener las estadísticas.' };
    }
};

const CheckDuplicateParticipant = async (email, phone) => {
    try {
        const response = await DLRubaQuiz.CheckDuplicateParticipant(email, phone);
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al verificar duplicidad del registro.' };
    }
};

const ResetRubaQuizData = async () => {
    try {
        const response = await DLRubaQuiz.ResetRubaQuizData();
        return response;
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar reiniciar la dinámica.' };
    }
};

export {
    GetQuestions,
    SubmitQuiz,
    GetSettings,
    GetAdminParticipants,
    ToggleVisibility,
    SelectWinner,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    ToggleActiveTrivia,
    TrackMetric,
    GetAdminStats,
    CheckDuplicateParticipant,
    ResetRubaQuizData
};
